/* 루미나 화면 층 신작 — 블랙 pages/HomePage.jsx 의 로직 그대로, JSX·CSS 만 교체(시안 홈: 히어로 카드 열차·공지·WHAT'S HOT 밴드·
   게임사 슬롯|카지노 탭 그리드·신규게임 원호 캐러셀·추천게임 세로 흐름·바로가기·스포츠·이벤트·CTA·게임 리스트 팝업).
   WHY: SPEC §2 — 훅·상태·API 호출·핸들러·조건 분기(게임종류 토글·블록 표시/숨김·탭 모드·퀵링크 설정·아이콘 토큰)는 블랙 원문을 유지하고,
        화면 구조만 시안대로 다시 그린다. 표현 애니메이션(열차·캐러셀·세로 흐름)은 components/home/* 로 분리했다.
   블록 순서·숨김: 각 구역에 정본 키(data-block)를 달고 HomePage.css 가 has-block-order / hide-block-* 를 소비한다. */
import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
// [2026-05-20 Phase 3 GUI] 슬롯·위젯 시스템 — 운영자가 사이트설정 > 디자인설정 > 위젯 배치에서 추가한 위젯을 슬롯별로 렌더
import WidgetSlot from "../components/widgets/WidgetSlot";
import { Link, useNavigate } from 'react-router-dom';
import NoticeSliderAPI from '../components/layout/NoticeSliderAPI';
import QuickMenu from '../components/layout/QuickMenu';
import GameSlider from '../components/sliders/GameSlider';
import SearchBox from '../components/common/SearchBox';
import JackpotSlider from '../components/sliders/JackpotSlider';
import GamePopup from '../components/common/GamePopup';
import ProviderGrid from '../components/common/ProviderGrid';
// [2026-06-09] 카지노 게임사 그리드 블록(디자인설정 표시/숨김 제어)을 위해 재도입.
//   클릭은 로비 직진입(컴포넌트 내장) — 슬롯 그리드(게임목록 팝업)와 경로 분리해 직전 '슬롯→카지노 로비 누수' 버그 회귀 방지.
import CasinoProviderGrid from '../components/common/CasinoProviderGrid';
import gamesService, { gameListErrorMessage } from '../services/games';
import GameListStatus from '../components/common/GameListStatus';
import eventsService from '../services/events';
import sportsService from '../services/sports';
import { SPORT_ICONS, DefaultSportIcon } from '../components/sports/SportsCategoryList';
import { getCountryFlagUrl } from '../components/sports/SportsMatchList';
import { getProviderNames } from '../utils/providerUtils';
import vendorNameService from '../services/vendorNameService';
import { getProviderCharacterPath, resolveApiImageUrl } from '../utils/logoUtils';
import { getCustomGradient } from '../utils/gameUtils';
import useAuth from '../hooks/useAuth';
import useModal from '../hooks/useModal';
import Modal from '../components/common/Modal';
// [2026-06-09] 히어로 슬라이더를 관리자 hero-banner 위젯(slide) 데이터로 구동하기 위해 designTemplate 접근.
//   App.js 가 useDomainTheme 결과를 DesignTemplateProvider 로 배포하므로 Context 사용 시 추가 fetch·부수효과 없음.
import { useDesignTemplate } from '../contexts/DesignTemplateContext';
// [루미나] 홈 전용 표현 부품 — 히어로 카드 열차 · 신규게임 원호 캐러셀 · 추천게임 세로 흐름 · 게임사 카드 그리드(슬롯/카지노)
import HeroTrain from '../components/home/HeroTrain';
import FeaturedArc from '../components/home/FeaturedArc';
import RecoFlow from '../components/home/RecoFlow';
import HomeProviderGrid from '../components/home/HomeProviderGrid';
import HomeCasinoProviderGrid from '../components/home/HomeCasinoProviderGrid';
import { ArrowIcon, gameThumbSrc, gameDisplayName, onEnterOrSpace, providerCodeOf, isVideoSrc, parseHeroCardTokens, buildHeroCards } from '../components/home/homeShared';
// [2026-09-30 운영자 지시] 구간 제목·설명·소개 글·"지금 시작하기" 글자 = 관리자 '홈 문구'(읽는 곳은 이 모듈 하나)
import { useHomeCopy, homeCopyLinkTarget } from '../components/home/homeCopy';
// [2026-09-30 운영자 지시] 링·방울 장식(참고 사이트 그대로) + 관리자 그림 주소 판정(띠 그림·장식 그림 공용)
import { DecorRings, DecorBubbles, useDecorImages, lmImageSrc } from '../components/home/LuminaDecor';
import './HomePage.css';

/* [2026-09-28] 첫 화면 이벤트 카드 배경이 영상 파일인지(확장자) — 관리자가 영상을 올리면 <video> 로 그린다(메인 히어로 슬라이드와 같은 허용).
   [2026-09-30] 판정(isVideoSrc)·카드 조립(buildHeroCards)은 components/home/homeShared.jsx 에 있다(로그인 패널과 함께 쓰려고 옮겼고,
   그 패널은 2026-10-01 운영자 지시로 없앴다 — 지금은 이 홈만 쓴다). */

/* [2026-07-29] 히어로 슬라이드를 코드에 박아두던 정의(3장)를 제거했다.
   WHY: 관리자 디자인설정의 '4. 메인 히어로 슬라이드'에 등록한 것만 화면에 나와야 한다.
        코드값이 남아 있으면 등록이 없을 때 그걸 대신 보여줘서, 화면에는 있는데 관리자에는
        0장으로 보이는 상태가 되고 그 슬라이드를 고치지도 지우지도 못한다.
        디자인1 화면 틀도 같은 이유로 이미 제거했다(2026-07-27). */

/* ── Quick Links (4-column bar) ──
   각 항목에 iconKey 부여(아래 ICON_TOKEN_KEYS 참조). 운영자가 디자인설정에서
   해당 키에 이미지 URL 을 지정하면 FontAwesome 클래스 대신 <img> 로 렌더, 미지정 시 기존 FA 폴백. */
const QUICK_LINKS = [
  { icon: 'fab fa-telegram-plane', label: '블랙 텔레그램', href: '#', iconKey: 'quicklink-0' },
  { icon: 'fas fa-globe', label: '블랙 평생도메인', href: '#', iconKey: 'quicklink-1' },
  { icon: 'fas fa-tv', label: '블랙 가족전용TV', href: '#', iconKey: 'quicklink-2' },
  { icon: 'fas fa-play-circle', label: '하이라이트', href: '#', iconKey: 'quicklink-3' },
];

/* ── Category banners ──
   사용자 요청으로 스포츠/인플레이/카지노/슬롯만 노출.
   해외형·홀덤·토큰게임·미니게임·가상경기·가족전용TV 항목 제거됨. */
/* 아이콘은 OS 컬러 이모지 — SPORT_ICONS와 동일한 렌더링 전략으로 별도
   이미지 자원·폰트 로딩 없이 실사풍 컬러 아이콘이 모든 환경에서 보임. */
/* gameType: 운영사 게임종류 토글(카지노/슬롯/스포츠)과 1:1 매핑 — 미운영 종류는 배너에서 제외 */
/* iconKey: 운영자가 디자인설정에서 이미지 URL 을 지정하면 emoji 대신 <img> 로 렌더(아래 ICON_TOKEN_KEYS 참조). */
/* [루미나] 카테고리 카드 구역은 시안에서 제거됐다(운영자 지시). 이 정의는 WHAT'S HOT 밴드가 '카테고리 글자' 토큰을
   같은 키로 읽는 데 쓰인다(게임종류 토글 필터 포함). */
const CATEGORY_BANNERS = [
  { label: '스포츠', emoji: '🏆', path: '/sports', gameType: 'sports', iconKey: 'category-sports' },
  { label: '인플레이', emoji: '🏟️', path: '/sports', gameType: 'sports', iconKey: 'category-inplay' },
  { label: '카지노', emoji: '🎲', path: '/casino', gameType: 'casino', iconKey: 'category-casino' },
  { label: '슬롯', emoji: '🎰', path: '/slot', gameType: 'slot', iconKey: 'category-slot' },
];

/* ── 아이콘 토큰 키 정의 (모듈 상수, 하드코딩 산재 방지) ──
   design_tokens.icons[키] 에 운영자가 업로드한 이미지(svg 등) URL 을 담는다.
   - category-* : 카테고리 카드(.black-category-card) 아이콘
   - quicklink-N: 바로가기 바(.black-quicklink) N번째 항목 아이콘
   값이 있으면 <img src=URL> 로 교체, 없으면 기존 emoji/FontAwesome 폴백(미설정 도메인 화면 100% 동일=무손상).
   이 키 목록은 관리자 DesignTokenEditor 의 '아이콘' 입력 UI 와 1:1 로 동기화되어야 한다(라벨 포함). */
const ICON_TOKEN_KEYS = {
  CATEGORY_SPORTS: 'category-sports',
  CATEGORY_INPLAY: 'category-inplay',
  CATEGORY_CASINO: 'category-casino',
  CATEGORY_SLOT: 'category-slot',
  QUICKLINK_0: 'quicklink-0',
  QUICKLINK_1: 'quicklink-1',
  QUICKLINK_2: 'quicklink-2',
  QUICKLINK_3: 'quicklink-3',
};

/* [루미나] 바로가기 칸의 기본 아이콘 — 블랙의 FontAwesome 클래스(QUICK_LINKS.icon) 대신 인라인 SVG(이모지·아이콘 폰트 금지).
   운영자가 아이콘 토큰(quicklink-N)에 이미지를 지정하면 그 이미지가 우선한다(블랙 규칙 그대로). */
const QUICK_LINK_ICONS = {
  'quicklink-0': <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21.5 3.5 2.8 10.7c-1 .4-1 1 0 1.3l4.8 1.5 1.8 5.6c.2.6.4.8.9.8.4 0 .6-.2.9-.5l2.6-2.5 5 3.7c.9.5 1.6.2 1.8-.9L23 5c.3-1.3-.5-1.9-1.5-1.5Z" /></svg>,
  'quicklink-1': <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" /></svg>,
  'quicklink-2': <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true"><rect x="3" y="5" width="18" height="13" rx="2" /><path d="M8 21h8M12 18v3" /></svg>,
  'quicklink-3': <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M10 8.5v7l6-3.5z" /></svg>,
};

/* [루미나] 히어로 액션 줄(블랙 3단 승계) 아이콘 — 게임규정·배팅내역·경기결과·출석체크 */
const ACTION_ICONS = {
  guide: <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" /></svg>,
  betting: <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" /></svg>,
  results: <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 14l-5-5 1.41-1.41L11 14.17l7.59-7.59L20 8l-9 9z" /></svg>,
  attendance: <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>,
};

/* [루미나] 이벤트 카드 상태 필 — 블랙 EventPageAPI 의 상태 표기와 같은 낱말(active→진행중, scheduled→예정). 메인 고정 목록은 이 둘만 담긴다 */
const EVENT_STATUS_LABEL = { active: '진행중', scheduled: '예정' };

const ChevronLeft = () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6" /></svg>);
const ChevronRight = () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>);
const SearchIcon = () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>);
const CloseIcon = () => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>);
const SparkIcon = () => (<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.4 6.6L21 11l-6.6 2.4L12 20l-2.4-6.6L3 11l6.6-2.4z" /></svg>);

const HomePage = () => {
  const navigate = useNavigate();
  const { user, isGameTypeEnabled } = useAuth();
  // [2026-06-09] 관리자 hero-banner 위젯(slide) 데이터로 히어로 슬라이더를 구동(미설정 시 HERO_SLIDES 폴백)
  const designTemplate = useDesignTemplate();
  // [2026-09-30] 관리자 '홈 문구' — 제목 칸이 비면 아래 각 구간의 기본 제목, 설명 칸이 비면 그 줄 없음(규칙은 homeCopy.js)
  const homeCopy = useHomeCopy();
  // [2026-09-30] 장식 그림(관리자 '장식 그림') — 비어 있으면 그 장식 없음
  const decor = useDecorImages();
  // WHY: 게임 실행 실패 사유를 네이티브 alert 대신 공용 정적 모달로 노출(화면전환에 묻혀 사라지는 문제 해소)
  const { isOpen: isAlertOpen, modalConfig: alertConfig, showAlert, openModal, closeModal: closeAlert } = useModal();

  /* ── Original state (preserved) ── */
  const [popularGames, setPopularGames] = useState([]);
  const [newGames, setNewGames] = useState([]);
  const [recommendedGames, setRecommendedGames] = useState([]);
  const [providers, setProviders] = useState([]);
  const [pinnedEvents, setPinnedEvents] = useState([]);
  const [eventLoading, setEventLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('slot');
  const [slotProviders, setSlotProviders] = useState([]);
  // [2026-06-09] 카지노 게임사 그리드 블록 재도입 — 슬롯 그리드(게임목록 팝업)와 분리, 카지노는 로비 직진입
  const [casinoProviders, setCasinoProviders] = useState([]);
  const [vendorNames, setVendorNames] = useState({});

  /* Provider popup state */
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [providerGames, setProviderGames] = useState([]);
  const [filteredGames, setFilteredGames] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [showProviderPopup, setShowProviderPopup] = useState(false);
  const [gameListLoading, setGameListLoading] = useState(false);
  const [gameListError, setGameListError] = useState('');
  const [isMobileIOS, setIsMobileIOS] = useState(false);

  /* Game popup state */
  /* [2026-08-12] 게임 창이 열려 있는지를 ref 로도 들고 있는다.
     WHY: 아래 화면 이탈 정리는 한 번만 등록되는 처리라, 그 안에서 상태값을 읽으면
       화면에 처음 들어왔을 때의 값(닫힘)만 보인다. 이탈하는 순간의 실제 값이 필요하다. */
  const gamePopupOpenRef = useRef(false);
  const [showGamePopup, setShowGamePopup] = useState(false);
  const [gameUrl, setGameUrl] = useState('');
  const [selectedGame, setSelectedGame] = useState(null);
  const [gameLoading, setGameLoading] = useState(false);
  const [customTitle, setCustomTitle] = useState(null);

  /* ── New state for Black design ── */
  const [heroIndex, setHeroIndex] = useState(0);
  const [sportsMatches, setSportsMatches] = useState([]);
  // [2026-06-09] 아이콘 토큰 URL 로드 실패(404·삭제·오타) 시 해당 키를 기록 → getIconUrl 이 null 반환 → 기존 emoji/FA 폴백.
  //   미설정 폴백뿐 아니라 '설정 후 파일이 사라진' 경우에도 깨진 이미지 대신 기본 아이콘이 보이게 한다(무손상 강화).
  const [failedIconKeys, setFailedIconKeys] = useState({});
  /* [2026-09-28] WHAT'S HOT 띠 마스코트로 불러오다 실패한 캐릭터 주소 — 다음 게임사 캐릭터로 넘어가는 데 쓴다 */
  const [failedMascotUrls, setFailedMascotUrls] = useState({});
  /* [2026-09-28] 게임사 목록(슬롯·카지노) 불러오기가 끝났는지 — 첫 화면 카드는 이 뒤에 한 번에 만든다(카드 수가 나눠 바뀌면 줄이 튄다) */
  const [providersReady, setProvidersReady] = useState(false);
  /* [2026-09-28] 첫 화면 카지노 게임사 카드가 로비를 열어 달라고 넘긴 게임사(히어로 전용 로비 인스턴스가 받아 처리) */
  const [heroLobbyProvider, setHeroLobbyProvider] = useState(null);
  const categoryScrollRef = useRef(null);
  const sportsScrollRef = useRef(null);
  const eventsScrollRef = useRef(null);

  /* [2026-09-28 운영자 지시] 첫 화면 카드 = 관리자 디자인설정 > 루미나 > "첫 화면 카드"(design_tokens.hero_cards)에서 고른 카드만.
     WHY: ① 종전 카드 줄은 메인 히어로 슬라이드(블랙에서 복사된 스포츠 광고 1장) + 자동 인기 게임 5장이라 관리자에는 1장인데
            화면엔 6장이 떴고, 게임 카드는 어디서도 고르거나 지울 수 없었다(07-29 원칙 "화면에 나오는 것은 관리자에서 고치고 지울 수 있어야" 위반).
          ② 운영자 요구: 카드를 직접 고르고, 게임으로 보일지 게임사로 보일지 정하고, 그림을 바꿀 수 있어야 한다.
     루미나는 "메인 히어로 슬라이드"(hero-banner slide 위젯)를 읽지 않는다 — 첫 화면은 이 목록 하나가 정본(관리자 화면에도 안내).
     카드 항목(관리자 HeroCardsEditor 가 저장): { id, type:'event'|'game'|'provider', enabled, image?, overlay?, title?,
       game?:{id,name,vendor,thumbnail}, provider?:{code,gameType,name} } — 게임·게임사 카드의 image·overlay·title 은 '바꾸기'(비우면 자동).
     실행할 수 없는 대상(게임사가 노출·선택·게임종류 제한으로 목록에서 빠짐)은 화면에서 뺀다 — 누르면 오류가 나는 카드를 남기지 않는다.
     카드는 게임사 목록이 도착한 뒤(providersReady) 한 번에 만든다 — 카드 수가 나눠 바뀌면 줄이 다시 세워져 튀었다(실측 한 프레임 550~744px). */
  const heroCardTokens = useMemo(() => parseHeroCardTokens(designTemplate), [designTemplate]);

  /* [2026-09-30 운영자 "사이트 접속시 왜 느린거야?" → 진행] 첫 화면 카드 그림을 미리 받기 시작한다.
     WHY: 카드는 게임사 목록이 온 뒤에 그려지고, 그림 요청은 그때서야 나갔다(그림마다 Cloudflare 경유 약 1초 — 실측).
          카드 설정(디자인 토큰)에 이미 적혀 있는 주소(배경·캐릭터 바꾸기, 게임 그림)는 목록을 기다릴 필요가 없으므로
          홈이 열리자마자 받아 두면, 카드가 그려질 때 브라우저가 받아 둔 그림을 바로 쓴다. 주소는 카드 그리기와 같은 규칙으로 만든다.
          (게임사 자동 캐릭터는 게임사 목록에서 주소가 정해져 카드와 같은 시점에 받는다) */
  useEffect(() => {
    const urls = new Set();
    heroCardTokens.forEach((c) => {
      if (!c || c.enabled === false) return;
      if (typeof c.image === 'string' && c.image.trim() && !isVideoSrc(c.image)) urls.add(c.image.trim());
      if (typeof c.overlay === 'string' && c.overlay.trim()) urls.add(c.overlay.trim());
      if (c.type === 'game' && c.game && c.game.thumbnail && !(typeof c.image === 'string' && c.image.trim())) {
        urls.add(gameThumbSrc({ thumbnail_url: c.game.thumbnail }));
      }
    });
    urls.forEach((src) => { const img = new Image(); img.decoding = 'async'; img.src = src; });
  }, [heroCardTokens]);

  /* 게임사 표시 이름 — 홈 게임사 카드(HomeProviderGrid)와 같은 우선순위(한글 이름 → 게임사 이름 사전 → 기본 이름표) */
  const providerKoreanName = useCallback((provider) => {
    const code = String(providerCodeOf(provider));
    return provider.name_ko || (vendorNames && vendorNames[code.toLowerCase()]) || getProviderNames(code).korean || provider.name || code;
  }, [vendorNames]);

  /* 카드 조립 규칙(게임·게임사·이벤트, 실행 불가 대상 빼기) — components/home/homeShared.jsx buildHeroCards */
  const heroCards = useMemo(() => {
    if (!providersReady) return [];
    return buildHeroCards(heroCardTokens, { slotProviders, casinoProviders, providerName: providerKoreanName });
  }, [providersReady, heroCardTokens, slotProviders, casinoProviders, providerKoreanName]);
  /* 현재 장이 카드 수 범위를 넘지 않게(렌더 전용). 끝에서 처음으로 되감지 않으므로 나머지 연산 대신 끝에 붙인다 */
  const safeHeroIndex = heroCards.length ? Math.min(heroIndex, heroCards.length - 1) : 0;

  /* ── Effects (original + new) ── */
  useEffect(() => {
    loadGameData();
    loadPinnedEvents();
    /* [운영사 게임종류 토글] 스포츠 미운영이면 경기 데이터 fetch 자체를 생략.
       enabledGameTypes가 null(비로그인/로딩전)이면 true → 기존과 동일하게 호출(no-op). */
    if (isGameTypeEnabled('sports')) {
      loadSportsMatches();
    }

    const checkMobileIOS = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      const isMobile = window.innerWidth <= 768;
      setIsMobileIOS(isIOS && isMobile);
    };

    checkMobileIOS();
    window.addEventListener('resize', checkMobileIOS);

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('resize', checkMobileIOS);
      /* [2026-08-12] 게임 창을 켜 둔 채 화면을 벗어날 때 종료를 알린다.
         WHY(실측): 홈 슬라이드에서 게임을 켜면 서버에 게임 기록이 실제로 생기는데,
           끝났다는 통보가 닫기 버튼과 브라우저 닫기에만 있었다. 게임을 켠 채 다른 메뉴로
           이동하면 알려 줄 주체가 없어 서버는 계속 게임 중으로 알았고, 회원관리 접속상태가
           '게임중'으로 잔류했다. 접속상태는 표시뿐 아니라 잔액 맞춤·관리자 작업을 막는 조건이다.
         닫기 버튼으로 닫는 경우는 종전대로 그쪽에서 알린다(닫으면 이 값이 꺼져 중복되지 않는다).
         슬롯 화면에 이미 같은 방식이 들어가 있다. */
      /* [2026-08-21] 화면 안 덧창은 화면과 함께 사라지므로 게임도 확실히 끝난다 → 확정 종료. */
      if (gamePopupOpenRef.current) {
        gamesService.endGame(true).catch(err => console.error('[HomePage] 화면 이탈 시 게임 종료 실패:', err));
      }
    };
  }, []);

  /* [2026-08-12] 게임 창 열림 상태를 위 ref 에 계속 반영한다(화면 이탈 시점의 실제 값을 쓰기 위함). */
  useEffect(() => {
    gamePopupOpenRef.current = showGamePopup;
  }, [showGamePopup]);

  /* [2026-09-28] 첫 화면 카드 줄의 5초 자동 넘김을 없앴다(운영자 "자연스럽지 못하고 통통 튕긴다").
     WHY: 시안·참조 사이트는 스크롤할 때만 카드가 움직였고, 자동 넘김은 블랙 슬라이더를 물려받으며 붙었다.
          5초마다 급출발하고 마지막 카드에서 처음으로 5칸을 0.93초에 되감아(실측) 튀어 보였다.
     [2026-09-29 운영자 지시] 카드 줄 아래 이전/다음 화살표·점 줄도 없앴다 — 카드는 스크롤로 움직인다. */

  /* ── Data loaders (original, preserved) ── */
  /* [2026-09-30 운영자 "사이트 접속시 왜 느린거야?" → 진행] 요청을 한 줄로 기다리지 않고 동시에 보낸다.
     WHY: 종전에는 ① 게임 이름 사전 응답을 기다린 뒤 ② 게임·게임사 목록 6개를 보내고 ③ 6개가 다 와야 첫 화면 카드를 만들었다.
          요청 하나가 Cloudflare 경유로 0.7~1초라(서버 직결 0.007초, 실측) 기다리는 단계가 하나 늘 때마다 그만큼 늦게 떴다.
          · 게임 이름 사전은 표시 이름용이라 목록과 동시에 보낸다(도착하면 이름만 바뀐다 — 카드 수는 그대로라 줄이 다시 서지 않는다).
          · 첫 화면 카드는 게임사 목록(슬롯·카지노)만 있으면 만든다 — 인기·신규·추천 목록은 따로 와도 된다.
          실패 처리는 묶음마다 따로 한다(한 묶음이 실패해도 다른 묶음은 그대로 쓴다). 슬롯 게임사에서 라이브 카지노 전용을 빼는 규칙은 종전 그대로. */
  const loadGameData = async () => {
    const vendorNamesTask = vendorNameService.getVendorNames()
      .then((vendorNamesData) => setVendorNames(vendorNamesData || {}))
      .catch((vendorError) => {
        console.warn('Failed to load vendor names, using fallback:', vendorError);
        setVendorNames({});
      });

    // [2026-06-09] 카지노 게임사 그리드 블록 재도입에 따라 카지노 제공사도 로드(3002 검증 패턴, 실패 시 catch 빈배열)
    const providerListsTask = Promise.all([
      gamesService.getProviders('slot'),
      gamesService.getProviders('casino'),
    ])
      .then(([slotProvidersData, casinoProvidersData]) => {
        setCasinoProviders(casinoProvidersData.providers || []);
        const liveCasinoOnlyProviders = ['EVOLUTION', 'AG', 'DREAMGAME', 'EZUGI', 'MG', 'SEXY', 'VIVO', 'WM'];
        const filteredSlotProviders = (slotProvidersData.providers || []).filter((provider) => {
          const providerName = provider.provider || provider.provider_name || provider.name;
          return !liveCasinoOnlyProviders.includes(providerName?.toUpperCase());
        });
        setSlotProviders(filteredSlotProviders);
      })
      .catch((error) => {
        console.error('게임사 목록 로드 실패:', error);
        setSlotProviders([]);
        setCasinoProviders([]);
      })
      /* [2026-09-28] 성공·실패와 상관없이 게임사 목록 불러오기가 끝났다 — 첫 화면 카드는 이 뒤에 한 번에 만든다 */
      .finally(() => setProvidersReady(true));

    const gameListsTask = Promise.all([
      gamesService.getPopularGames(20),
      gamesService.getNewGames(20),
      gamesService.getRecommendedGames(20),
      gamesService.getProviders(),
    ])
      .then(([popularData, newData, recommendedData, providersData]) => {
        setPopularGames(popularData.games || []);
        setNewGames(newData.games || []);
        setRecommendedGames(recommendedData.games || []);
        setProviders(providersData.providers || []);
      })
      .catch((error) => {
        console.error('게임 데이터 로드 실패:', error);
        setPopularGames([]);
        setNewGames([]);
        setRecommendedGames([]);
        setProviders([]);
      });

    await Promise.all([vendorNamesTask, providerListsTask, gameListsTask]);
  };

  const loadPinnedEvents = async () => {
    setEventLoading(true);
    try {
      // [2026-05-03] 슬라이드 한도 파라미터화에 맞춰 프론트 임의 제한(slice(0,6)) 제거.
      //   백엔드 `/events/pinned/list?limit=` 디폴트 30, 상한 100. 노출 개수는 백엔드가
      //   결정하도록 일원화하여 운영자가 한 곳(쿼리/디폴트)만 조정하면 일관 반영되게 한다.
      const response = await eventsService.getPinnedEvents();
      if (response.success && response.data) {
        const activeEvents = response.data.filter(
          (event) => event.status === 'active' || event.status === 'scheduled'
        );
        setPinnedEvents(activeEvents);
      }
    } catch (error) {
      console.error('메인 고정 이벤트 로드 실패:', error);
      setPinnedEvents([]);
    } finally {
      setEventLoading(false);
    }
  };

  /* ── New: load upcoming sports matches (SWR + sessionStorage 캐시) ──
     홈 스포츠 슬라이드는 재진입·새로고침 시 즉시 노출이 중요하므로
     stale-while-revalidate 전략을 적용한다:
       1) 캐시(TTL 60초) 있으면 즉시 setState → 사용자 화면 0ms 렌더
       2) 항상 백그라운드에서 fresh fetch → 도착 시 교체 + 캐시 갱신
     캐시는 sessionStorage 사용(탭 단위, 쿠키/보안 정보 없음). */
  const SPORTS_CACHE_KEY = 'ur5:home:sports-matches';
  const SPORTS_CACHE_TTL_MS = 60 * 1000;

  const readSportsCache = () => {
    try {
      const raw = sessionStorage.getItem(SPORTS_CACHE_KEY);
      if (!raw) return null;
      const { ts, data } = JSON.parse(raw);
      if (!Array.isArray(data)) return null;
      if (Date.now() - ts > SPORTS_CACHE_TTL_MS) return null;
      return data;
    } catch {
      return null;
    }
  };

  const writeSportsCache = (data) => {
    try {
      sessionStorage.setItem(SPORTS_CACHE_KEY, JSON.stringify({ ts: Date.now(), data }));
    } catch {
      /* storage full/disabled — 무시 */
    }
  };

  const loadSportsMatches = async () => {
    // 1) 캐시 선반영 (체감 속도 개선의 핵심)
    const cached = readSportsCache();
    if (cached && cached.length > 0) {
      setSportsMatches(cached);
    }

    // 2) 백그라운드 fresh fetch
    try {
      const matches = await sportsService.getMatches({ limit: 10, betType: 'prematch_all' });
      let list = [];
      if (Array.isArray(matches)) list = matches.slice(0, 10);
      else if (matches && Array.isArray(matches.matches)) list = matches.matches.slice(0, 10);

      if (list.length > 0) {
        setSportsMatches(list);
        writeSportsCache(list);
      } else if (!cached) {
        setSportsMatches([]);
      }
    } catch (err) {
      console.warn('Sports matches load failed:', err);
      if (!cached) setSportsMatches([]);
    }
  };

  /* ── Original handlers (preserved) ── */
  const handleProviderSelect = async (provider) => {
    try {
      const data = await gamesService.getGameList({ vendor: provider.provider || provider.provider_name, type: 'slot' });
      navigate('/slot', { state: { selectedProvider: provider, games: data.games || [] } });
    } catch (error) {
      console.error('게임사 게임 목록 로드 실패:', error);
      navigate('/slot');
    }
  };

  // [2026-11-02] 마지막으로 누른 게임사만 창을 열고 실패를 안내한다. 응답이 막힌 동안 여러 번 누르면 안내가 반복되거나
  //   다른 게임사 목록 위에 떴다. 화면을 떠나면 번호를 올려 늦은 실패를 안내하지 않는다(2026-11-02 독립 검토).
  const providerClickSeqRef = useRef(0);
  useEffect(() => () => { providerClickSeqRef.current += 1; }, []);

  const handleSlotProviderClick = async (provider) => {
    if (!user) {
      alert('로그인이 필요합니다.');
      navigate('/login');
      return;
    }
    const seq = ++providerClickSeqRef.current;
    try {
      // [2026-11-01] 띄어쓰기를 밑줄로 바꾸지 않는다 — 게임사 표준 코드에 띄어쓰기가 있는 곳(NOLIMIT CITY·PG SOFT)은 밑줄 표기로 물으면 서버가 게임 0개를
      //   돌려줘 게임 목록이 비었다(2026-11-01 ur3 실측: 노리밋시티 139·PG소프트 177 → 0). 서버는 대소문자를 무시하고 표준 코드와 그대로 맞춘다.
      const providerCode = (provider.provider || provider.provider_name || '').toLowerCase();
      // [2026-11-03] 창을 먼저 열고 목록은 창 안에서 기다린다. WHY: 목록을 다 받은 뒤에 창을 열어, 응답이 밀리면 눌러도 몇 초~십수 초 아무 반응이 없었다(운영자 신고 "팝업이 늦게 뜨거나 뜨지 않는다").
      setSelectedProvider(provider);
      setProviderGames([]);
      setFilteredGames([]);
      setSearchKeyword('');
      setGameListError('');
      setGameListLoading(true);
      setShowProviderPopup(true);
      // 팝업 열 때 body 스크롤 방지
      document.body.style.overflow = 'hidden';
      const data = await gamesService.getGameList({ vendor: providerCode, game_type: 'slot' });
      if (seq !== providerClickSeqRef.current) return;   // 그 사이 다른 게임사를 눌렀거나 창을 닫았거나 화면을 떠났다
      const games = data.data || data.games || [];
      setProviderGames(games);
      setFilteredGames(games);
    } catch (error) {
      console.error('게임 목록 로드 실패:', error);
      // 창 안에 사유와 [다시 시도]를 보여 준다(알림창을 겹쳐 띄우지 않는다)
      if (seq !== providerClickSeqRef.current) return;
      setGameListError(gameListErrorMessage(error));
    } finally {
      if (seq === providerClickSeqRef.current) setGameListLoading(false);
    }
  };

  // handleCasinoGameListFallback 제거: 카지노는 로비 직진입 정책으로 일원화되어 게임 목록 폴백 미사용

  const closeProviderPopup = () => {
    providerClickSeqRef.current += 1;   // 창을 닫으면 늦게 온 목록·실패를 무시한다
    setGameListLoading(false);
    setGameListError('');
    setShowProviderPopup(false);
    setSelectedProvider(null);
    setProviderGames([]);
    setFilteredGames([]);
    setSearchKeyword('');
    document.body.style.overflow = '';
  };

  const handleGameSearch = (e) => {
    const keyword = e.target.value;
    setSearchKeyword(keyword);
    if (!keyword.trim()) {
      setFilteredGames(providerGames);
      return;
    }
    const filtered = providerGames.filter(
      (game) =>
        (game.game_name_ko && game.game_name_ko.toLowerCase().includes(keyword.toLowerCase())) ||
        (game.game_name && game.game_name.toLowerCase().includes(keyword.toLowerCase()))
    );
    setFilteredGames(filtered);
  };

  const handleGameClick = async (game, vendorTitle = null) => {
    if (!game) return;
    setSelectedGame(game);
    setGameLoading(true);
    setCustomTitle(vendorTitle);
    try {
      const response = await gamesService.launchGame(game.id);
      const url = response.gameUrl || response.launch_url;
      if (url) {
        setGameUrl(url);
        setShowGamePopup(true);
      } else {
        throw new Error('게임 URL을 받지 못했습니다.');
      }
    } catch (error) {
      // WHY: 백엔드(routes/games.js:2710 의 'API 잔액이 부족합니다. 관리자에게 문의하세요.' 등)가
      // 명확한 사유 메시지를 보내는데 일반 메시지로 덮으면 회원이 거부 사유를 알 수 없어
      // 운영자에게 알릴 수도 없다. services/games.js 가 axios 에러를
      // `throw error.response?.data || error` 로 던지므로 error 는 plain object({ error:'...' }) 또는 Error.
      console.error('게임 실행 실패:', error);
      // 안 읽은 쪽지 차단은 services/api.js 가 쪽지 안내 창을 연다 — 같은 내용의 알림창을 겹쳐 띄우지 않는다(2026-11-01 ur3 실측: 창 2개 겹침)
      if (error?.code === 'UNREAD_NOTICE_GATE') return;
      const reason = error?.error || error?.message || '게임을 실행할 수 없습니다.';
      // WHY: 사유를 네이티브 alert 대신 공용 모달로 노출(사라짐 해소)
      showAlert(reason);
    } finally {
      setGameLoading(false);
    }
  };

  /* [루미나] 게임 목록 창을 ESC 로 닫는다(시안 게임 리스트 팝업 규칙: 닫기·배경 클릭·ESC).
     게임 실행 창(GamePopup)이 위에 떠 있으면 그 창의 ESC 처리에 맡겨 두 창이 한꺼번에 닫히지 않게 한다. */
  useEffect(() => {
    if (!showProviderPopup || showGamePopup) return undefined;
    const onKeyDown = (e) => { if (e.key === 'Escape') closeProviderPopup(); };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showProviderPopup, showGamePopup]);

  /* ── Helpers ── */
  /* [2026-09-29] 이벤트 카드를 누르면 그 칸으로 옮긴다(점·화살표 줄은 운영자 지시로 없앰) — 자동 넘김이 없으므로 타이머를 다시 세우지 않는다 */
  const goToSlide = (idx) => {
    setHeroIndex(idx);
  };

  const formatMatchDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const hh = String(d.getHours()).padStart(2, '0');
    const mi = String(d.getMinutes()).padStart(2, '0');
    return `${mm}-${dd} ${hh}:${mi}`;
  };

  // backend sportType → SPORT_ICONS 키 매핑 (SportsCategoryList.jsx의 키 셋과 일치)
  // basketball → basket, football → amfootball 처럼 alias 흡수
  const getSportIconNode = (sportType) => {
    const s = (sportType || '').toLowerCase();
    const alias = {
      basketball: 'basket',
      football: 'amfootball',
      'american football': 'amfootball',
      icehockey: 'hockey',
      'ice hockey': 'hockey',
    };
    const key = alias[s] || s;
    return SPORT_ICONS[key] || <DefaultSportIcon />;
  };

  /* horizontal scroll helper */
  const scrollContainer = (ref, dir) => {
    if (!ref.current) return;
    ref.current.scrollBy({ left: dir * 320, behavior: 'smooth' });
  };

  /* [2026-06-09] 아이콘 토큰 조회 — design_tokens.icons[키] 의 이미지 URL 을 반환(없으면 null).
     design_tokens 가 문자열(JSON)로 내려오는 경우(캐시 부트스트랩 경로)도 안전하게 파싱.
     null 이면 호출부에서 기존 emoji/FontAwesome 폴백을 그대로 렌더(무손상). */
  const iconTokens = useMemo(() => {
    let dt = designTemplate?.design_tokens;
    if (typeof dt === 'string') {
      try { dt = JSON.parse(dt); } catch (e) { return {}; }
    }
    const icons = dt?.icons;
    return (icons && typeof icons === 'object') ? icons : {};
  }, [designTemplate]);

  const getIconUrl = (key) => {
    if (failedIconKeys[key]) return null; // 로드 실패한 아이콘은 기본(emoji/FA)으로 폴백
    const url = iconTokens?.[key];
    return (typeof url === 'string' && url.trim()) ? url : null;
  };

  /* [2026-06-09] 레이아웃 토큰 조회 — design_tokens.layout 객체를 안전하게 read.
     iconTokens 와 동일 패턴(문자열 JSON 폴백 파싱). 미설정/파싱 실패 시 {} → 아래 폴백이 기존 동작 유지(무손상). */
  const layoutTokens = useMemo(() => {
    let dt = designTemplate?.design_tokens;
    if (typeof dt === 'string') {
      try { dt = JSON.parse(dt); } catch (e) { return {}; }
    }
    const layout = dt?.layout;
    return (layout && typeof layout === 'object') ? layout : {};
  }, [designTemplate]);

  /* [퀵링크 설정] design_tokens.quicklinks 배열로 퀵링크 4칸의 라벨·URL·표시여부를 관리자에서 제어.
     iconTokens 와 동일 파싱 패턴(문자열 JSON 폴백). 미설정/누락 시 아래 effectiveQuickLinks 가
     하드코딩 QUICK_LINKS 값으로 폴백 → 설정 안 한 도메인은 기존 화면 100% 유지(무손상).
     배열 index 는 아이콘 토큰(quicklink-N)·QUICK_LINKS 순서와 1:1 정렬. */
  /* [2026-07-29] 관리자 '디자인 토큰 편집 > 카테고리 글자 · 푸터 문구'에서 지정한 카테고리 글자.
     WHY: 홈 카테고리 칸의 글자가 코드에 박혀 있어 운영사가 바꿀 수 없었다.
     무손상: 지정이 없으면 빈 객체가 되어 아래 렌더에서 기존 글자를 그대로 쓴다. */
  const categoryLabelTokens = useMemo(() => {
    let dt = designTemplate?.design_tokens;
    if (typeof dt === 'string') {
      try { dt = JSON.parse(dt); } catch (e) { return {}; }
    }
    const cl = dt?.category_labels;
    return (cl && typeof cl === 'object') ? cl : {};
  }, [designTemplate]);

  const quicklinkTokens = useMemo(() => {
    let dt = designTemplate?.design_tokens;
    if (typeof dt === 'string') {
      try { dt = JSON.parse(dt); } catch (e) { return []; }
    }
    const ql = dt?.quicklinks;
    return Array.isArray(ql) ? ql : [];
  }, [designTemplate]);

  /* QUICK_LINKS(하드코딩 폴백)에 설정 토큰을 병합한 실제 렌더용 목록.
     label: 설정값 우선, 없으면 기존 텍스트. url: 설정 시 클릭→안내모달, 없으면 기존 무동작.
     enabled: 명시적으로 false 일 때만 숨김(미설정=노출, 기존 동작 보존). */
  const effectiveQuickLinks = useMemo(() => QUICK_LINKS.map((base, i) => {
    const t = quicklinkTokens[i] || {};
    return {
      ...base,
      label: (typeof t.label === 'string' && t.label.trim()) ? t.label : base.label,
      url: (typeof t.url === 'string' && t.url.trim()) ? t.url.trim() : '',
      enabled: t.enabled !== false,
    };
  }), [quicklinkTokens]);

  /* [2026-06-09] 게임사 표시 방식 — design_tokens.layout.provider_grid_mode.
     'tabs' 일 때만 3002식 단일 래퍼 탭 전환. 미설정/'list'/미인식 값은 모두 'list'(기본=현재 나열 화면) 폴백.
     → 옵션 미설정 도메인·구버전 토큰은 기존 .black-slots/.black-casino 2섹션 나열 100% 유지(무손상). */
  const providerMode = layoutTokens.provider_grid_mode === 'tabs' ? 'tabs' : 'list';

  /* [2026-06-09] 탭 모드 한정 hidden_blocks 정합성:
     나열 모드는 App.css 의 hide-block-black-slots/-casino 셀렉터가 각 섹션을 개별 숨김.
     탭 모드는 단일 래퍼(.black-providers-tabs)라 그 셀렉터가 닿지 않으므로, 여기서 JS 로 직접 AND 결합해
     "슬롯 게임사"/"카지노 게임사" 블록 토글 OFF 시 해당 탭이 사라지도록 나열 모드와 동작을 일치시킨다.
     hidden_blocks 미설정(기본)이면 둘 다 false → 두 탭 모두 노출(무손상). */
  const hiddenBlocks = Array.isArray(layoutTokens.hidden_blocks) ? layoutTokens.hidden_blocks : [];
  const slotBlockHidden = hiddenBlocks.includes('black-slots');
  const casinoBlockHidden = hiddenBlocks.includes('black-casino');

  /* [2026-06-09] 탭 노출 가능 여부 — 운영사 게임종류 토글(isGameTypeEnabled)과 hidden_blocks 토글을 함께 충족할 때만 해당 탭을 띄운다.
     enabledGameTypes 가 null(비로그인/로딩전)이면 isGameTypeEnabled 가 true → 토글 미설정과 동일하게 노출(no-op). */
  const slotTabAvailable = isGameTypeEnabled('slot') && !slotBlockHidden;
  const casinoTabAvailable = isGameTypeEnabled('casino') && !casinoBlockHidden;

  /* [2026-06-09] activeTab 보정 — 탭 모드에서 현재 활성 탭이 노출 불가(게임종류 OFF/블록 숨김)면 가용한 다른 탭으로 자동 전환.
     한쪽만 가용한 경우 빈 화면이 뜨지 않게 하고, 둘 다 불가하면 래퍼 자체가 미렌더되므로 보정 불필요(아래 렌더 가드). */
  useEffect(() => {
    if (providerMode !== 'tabs') return;
    if (activeTab === 'slot' && !slotTabAvailable && casinoTabAvailable) {
      setActiveTab('casino');
    } else if (activeTab === 'casino' && !casinoTabAvailable && slotTabAvailable) {
      setActiveTab('slot');
    }
  }, [providerMode, activeTab, slotTabAvailable, casinoTabAvailable]);

  /* [2026-06-09] 렌더 시점 유효 활성 탭 — activeTab 보정 useEffect 가 반영되기 전 1프레임 빈 그리드를 방지하기 위해
     렌더에서도 가용성을 즉시 반영한다. 현재 활성 탭이 가용하면 그대로, 아니면 가용한 다른 탭을, 둘 다 불가면 null. */
  const effectiveTab = (activeTab === 'slot' && slotTabAvailable) || (activeTab === 'casino' && casinoTabAvailable)
    ? activeTab
    : (slotTabAvailable ? 'slot' : (casinoTabAvailable ? 'casino' : null));

  /* [2026-09-28 운영자 지시] 헤드라인(시안 "새로운 / 전설" 자리) = 루미나 전용 '첫 화면 제목'(design_tokens.hero_headline {line1, line2}).
     WHY: 종전에는 현재 슬라이드의 제목·부제를 헤드라인으로 썼다. 슬라이드 문구는 배너용 문장이라(예: 32자) 시안의 짧고 큰 제목이
          되지 못했고, 슬라이드가 바뀔 때마다 제목도 바뀌었다. 이제 제목은 관리자 디자인설정의 루미나 항목에서 따로 정한다.
     비어 있으면 제목 없이 카드만 나온다(코드에 박는 기본 문구 없음). 다른 토큰과 같은 파싱 규칙(문자열 JSON 폴백). */
  const heroHeadline = useMemo(() => {
    let dt = designTemplate?.design_tokens;
    if (typeof dt === 'string') {
      try { dt = JSON.parse(dt); } catch (e) { return {}; }
    }
    const hh = dt?.hero_headline;
    return (hh && typeof hh === 'object') ? hh : {};
  }, [designTemplate]);

  /* [2026-09-30 운영자 지시] 소개 글 구간(WHAT'S HOT 띠 아래) — 참조 사이트(microgaming.io)의 "POWERED BY PASSION" 자리처럼
     큰 두 줄 제목 + 설명 + 버튼. 글자·주소는 관리자 '홈 문구 > 소개 글 구간'이고, 제목·설명이 모두 비면 구간을 그리지 않는다
     (코드에 박는 기본 문구 없음). 버튼은 글자와 쓸 수 있는 주소가 모두 있을 때만 — 주소 판정은 homeCopyLinkTarget 한 곳. */
  const introLine1 = homeCopy.field('intro', 'line1');
  const introLine2 = homeCopy.field('intro', 'line2');
  const introDesc = homeCopy.desc('intro');
  const introButtonLabel = homeCopy.field('intro', 'button');
  const introButtonTarget = introButtonLabel ? homeCopyLinkTarget(homeCopy.field('intro', 'link')) : null;
  const introVisible = Boolean(introLine1 || introLine2 || introDesc);

  /* [2026-09-30] "지금 시작하기"(비로그인 전용) — 제목 두 줄을 모두 비우면 기본 "지금 / 시작하기",
     안내 문장은 비면 줄 없음(시안: "회원가입 1분. …"), 버튼 글자는 비면 "회원가입". */
  const ctaLine1Custom = homeCopy.field('cta', 'line1');
  const ctaLine2Custom = homeCopy.field('cta', 'line2');
  const [ctaLine1, ctaLine2] = (ctaLine1Custom || ctaLine2Custom) ? [ctaLine1Custom, ctaLine2Custom] : ['지금', '시작하기'];
  const ctaDesc = homeCopy.desc('cta');
  const ctaButtonLabel = homeCopy.field('cta', 'button') || '회원가입';

  /* [루미나] WHAT'S HOT 밴드 문구 —관리자 '카테고리 글자' 토큰이 있으면 그 글자(운영 게임종류만), 없으면 시안 문구.
     흐르는 띠는 폭이 화면보다 넓어야 이어지므로 짝수 벌로 반복한다(같은 글자를 다시 그릴 뿐). */
  const bandLabels = CATEGORY_BANNERS
    .filter((cat) => isGameTypeEnabled(cat.gameType))
    .map((cat) => categoryLabelTokens[cat.iconKey])
    .filter((v) => typeof v === 'string' && v.trim());
  const bandLatin = bandLabels.length === 0;
  const bandUnit = bandLatin ? ["WHAT'S HOT"] : bandLabels;
  const bandRow = [];
  const bandReps = 2 * Math.ceil(4 / bandUnit.length);
  for (let r = 0; r < bandReps; r++) bandUnit.forEach((t) => bandRow.push(t));
  /* [2026-09-30 운영자 지시] 밴드 그림 = 관리자 '2. 디자인 토큰' > "WHAT'S HOT 띠 그림"(design_tokens.band_hot {background, character}) 우선.
     WHY: 띠 그림이 자동뿐이라 운영자가 정한 그림(참고 사이트의 띠 그림)을 쓸 수 없었다. 그림은 코드가 아니라 관리자에서 올린 파일이다.
     비어 있으면 종전 자동 — 배경 = 신규게임 첫 장 썸네일(흐림), 캐릭터 = 게임사 응답의 캐릭터(표시 금지 아닌 첫 곳).
     주소 판정은 장식 그림과 같은 한 곳(components/home/LuminaDecor.jsx lmImageSrc — 사이트 안 경로·http(s), 따옴표·괄호·공백 없을 때만). */
  const bandHotTokens = useMemo(() => {
    let dt = designTemplate?.design_tokens;
    if (typeof dt === 'string') {
      try { dt = JSON.parse(dt); } catch (e) { return {}; }
    }
    const bh = dt?.band_hot;
    return (bh && typeof bh === 'object' && !Array.isArray(bh)) ? bh : {};
  }, [designTemplate]);
  const bandBgCustom = lmImageSrc(bandHotTokens.background);
  const bandBg = bandBgCustom || (newGames.length ? gameThumbSrc(newGames[0]) : '');
  /* [2026-09-28] 마스코트 그림이 없는 파일(404)이면 다음 게임사 캐릭터로 넘어간다.
     WHY: 첫 게임사의 캐릭터 주소가 서버에 없는 파일을 가리키면(실측: 에볼루션 slot-evolution.png 404) 그림만 숨겨져
          띠가 거대한 글자만 남았다. 실패한 주소를 기억해 두고 다음 후보를 고른다(후보가 다 떨어지면 그리지 않는다).
     [2026-09-30] 관리자가 정한 캐릭터 그림이 있으면 그것이 첫 후보다(그 파일이 실패하면 같은 규칙으로 게임사 캐릭터로 넘어간다). */
  const bandCharCustom = lmImageSrc(bandHotTokens.character);
  const bandMascotAuto = providers.find((p) => p.character_url && p.character_hidden !== true
    && !failedMascotUrls[resolveApiImageUrl(p.character_url)]);
  const bandMascotSrc = (bandCharCustom && !failedMascotUrls[bandCharCustom])
    ? bandCharCustom
    : (bandMascotAuto ? resolveApiImageUrl(bandMascotAuto.character_url) : '');

  /* [루미나] 히어로 액션 줄 — 블랙 3단(게임규정·배팅내역·경기결과[스포츠 운영 시]·출석체크) 승계, 로그인 시에만 */
  const heroActions = user ? (
    <div className="container actions" id="actions">
      <Link className="btn-secondary act" to="/mypage/guide">{ACTION_ICONS.guide}게임규정</Link>
      <Link className="btn-secondary act" to="/mypage/betting-list">{ACTION_ICONS.betting}배팅내역</Link>
      {isGameTypeEnabled('sports') && <Link className="btn-secondary act" to="/sports/results">{ACTION_ICONS.results}경기결과</Link>}
      <Link className="btn-secondary act" to="/mypage/attendance">{ACTION_ICONS.attendance}출석체크</Link>
    </div>
  ) : null;

  /* 신규게임·추천게임 카드 클릭: 게임사 카드(handleSlotProviderClick)와 동일 규약으로 미로그인은 /login 이동,
     로그인 상태는 기존 게임 실행 인프라(handleGameClick → GamePopup)를 그대로 재사용(신규 구현 없음). */
  const onGameSlideClick = (game) => (user ? handleGameClick(game) : navigate('/login'));

  /* [2026-09-28] 히어로 카드 누름 — 게임 카드는 신규게임 카드와 같은 실행 규칙(onGameSlideClick),
     이벤트 카드(메인 히어로 슬라이드)는 종전처럼 그 칸으로 열차를 민다(블랙 슬라이더 규칙, 슬라이드에는 링크 칸이 없다). */
  const handleHeroCardActivate = (card, idx) => {
    if (card.kind === 'game') return onGameSlideClick(card.game);
    if (card.kind === 'provider') {
      /* 게임사 카드 = 홈 게임사 카드와 같은 규칙: 슬롯은 게임 목록 창, 카지노는 로비 입장(로비 절차는 히어로 전용 로비 인스턴스가 처리) */
      if (card.gameType === 'casino') return setHeroLobbyProvider(card.provider);
      return handleSlotProviderClick(card.provider);
    }
    return goToSlide(idx);
  };

  /* ──────────────────────── RENDER ──────────────────────── */
  return (
    <div className="home-page lm-home">
      {/* [2026-05-20 Phase 3 GUI] 위젯 슬롯 — 운영자가 사이트설정 > 디자인설정 > 위젯 배치에서 추가한 위젯이 여기에 렌더링됨 */}
      {/* [2026-06-09] hero-banner 의 slide 위젯은 아래 히어로 열차가 직접 소비하므로 여기선 제외(중복 방지).
          image/button 등 다른 위젯은 그대로 히어로 위에 렌더된다. */}
      <WidgetSlot slotKey="hero-banner" excludeTypes={['slide']} />
      <WidgetSlot slotKey="top-strip" />
      <WidgetSlot slotKey="promotion-section" />
      <WidgetSlot slotKey="footer-top" />

      {/* ====== 1. HERO — 고정(pin) + 스크롤 스크럽 카드 열차 ====== */}
      {/* 카드 배치는 safeHeroIndex(범위 보정)를 써 빈 화면·인덱스 초과를 막는다.
         관리자 '첫 화면 카드'에 켠 카드가 없으면 열차를 그리지 않는다 — 화면에 뜨는 것은 반드시 관리자에서 지울 수 있어야 한다(07-29 원칙).
         [루미나] 히어로 틀(.hero-pin)은 고정 헤더 아래 여백과 액션 줄을 담으므로 항상 두고, 그 안의 열차만 비운다. */}
      {/* [2026-09-28] 카드 줄 = 관리자 '첫 화면 카드'(이벤트·게임·게임사), 큰 제목 = 루미나 '첫 화면 제목' */}
      <HeroTrain
        cards={heroCards}
        activeIndex={safeHeroIndex}
        onActivate={handleHeroCardActivate}
        actions={heroActions}
        headline={heroHeadline}
      />
      {/* [2026-09-28] 첫 화면 카지노 게임사 카드 전용 로비 — 홈 카지노 카드와 같은 로비 절차(인증·확인 팝업·로비 창·닫힘 감지)를
          그대로 쓰되 카드 그리드는 그리지 않는다(showGrid=false). 요청을 받으면 비워서 같은 카드를 다시 눌러도 열린다. */}
      <HomeCasinoProviderGrid
        providers={[]}
        vendorNames={vendorNames}
        showGrid={false}
        lobbyRequest={heroLobbyProvider}
        onLobbyRequestHandled={() => setHeroLobbyProvider(null)}
      />

      {/* ====== 2. 공지 슬라이더 (블랙 NOTICE TICKER: 관리자 '블록 표시/숨김 > 공지 티커'(hide-block-notice)·순서 제어 대상) ====== */}
      <div className="home-notice" data-block="notice">
        <NoticeSliderAPI />
      </div>

      {/* [2026-06-08] 빌더 슬롯 — 카테고리 섹션 위(운영자가 위젯 배치에서 채움, 비면 미표시) */}
      <WidgetSlot slotKey="home-before-categories" />

      {/* ====== 3. WHAT'S HOT 다크 밴드(표현용) — 블랙 카테고리 구역은 시안에서 제거됐고 그 '카테고리 글자' 토큰만 여기서 흐른다 ====== */}
      <section className="band hot lm-band-hot" aria-hidden="true">
        {/* 관리자가 정한 배경(bandBgCustom)은 흐리지 않고 그대로(as-is) — 참고 사이트 실측: 배경 그림 흐림 없음 + 짙은 덮개 80%(.ov 와 같음) */}
        <div className="clip"><div className={`bgimg${bandBgCustom ? ' as-is' : ''}`} style={bandBg ? { backgroundImage: `url("${bandBg}")` } : undefined}></div><div className="ov"></div></div>
        {/* [2026-09-30] 방울 장식(참고 사이트: 띠 아래 오른쪽 21%, 120px) — 배경 위·글자 아래 */}
        <DecorBubbles bubble={decor.bubble} variant="band" />
        {bandMascotSrc && (
          <img
            key={bandMascotSrc}
            /* as-is = 관리자가 정한 캐릭터 그림 — 참고 사이트 실측 크기·자리 그대로(HomePage.css). 자동 캐릭터는 종전 규칙 */
            className={`mascot${bandCharCustom && bandMascotSrc === bandCharCustom ? ' as-is' : ''}`}
            src={bandMascotSrc}
            alt=""
            onError={() => {
              setFailedMascotUrls((prev) => ({ ...prev, [bandMascotSrc]: true }));
            }}
          />
        )}
        <div className="in" ref={categoryScrollRef}>
          <div className="marq"><div className="row">{bandRow.map((t, i) => (<React.Fragment key={i}><span className={`heading-1${bandLatin ? ' latin' : ''}`}>{t}</span><span className="mark"><SparkIcon /></span></React.Fragment>))}</div></div>
          <div className="marq rev"><div className="row">{bandRow.map((t, i) => (<React.Fragment key={i}><span className={`heading-1${bandLatin ? ' latin' : ''}`}>{t}</span><span className="mark"><SparkIcon /></span></React.Fragment>))}</div></div>
        </div>
      </section>

      {/* ====== 3-1. 소개 글 (2026-09-30 운영자 지시) — 관리자 '홈 문구 > 소개 글 구간'. 제목·설명이 모두 비면 미렌더 ======
          참조 사이트 소개 구간의 배치(큰 두 줄 제목·둘째 줄 들여쓰기·비켜 앉은 본문·1차 버튼)를 루미나 부품(heading-2·lead·btn-primary)으로 그린다.
          블록 순서는 WHAT'S HOT 밴드와 같은 값을 따른다(HomePage.css) → 밴드 → 소개 글 → 게임사 순서 유지. */}
      {introVisible && (
        <section className="intro">
          <div className="container">
            {/* [2026-09-30] 링 장식(참고 사이트 긴 글 구간과 같은 자리 — 1240 컨테이너 양쪽 가장자리) */}
            <DecorRings ring1={decor.ring1} ring2={decor.ring2} />
            {(introLine1 || introLine2) && (
              <h2 className="heading-2">
                {introLine1 && <span>{introLine1}</span>}
                {introLine2 && <span className="in2">{introLine2}</span>}
              </h2>
            )}
            {(introDesc || introButtonTarget) && (
              <div className="intro-body">
                {introDesc && <p className="lead">{introDesc}</p>}
                {introButtonTarget && (introButtonTarget.internal ? (
                  <Link to={introButtonTarget.href} className="btn-primary">{introButtonLabel} <span className="ic"><ArrowIcon /></span></Link>
                ) : (
                  <a href={introButtonTarget.href} className="btn-primary" target="_blank" rel="noopener noreferrer">{introButtonLabel} <span className="ic"><ArrowIcon /></span></a>
                ))}
              </div>
            )}
          </div>
        </section>
      )}

      {/* ====== 4. 슬롯/카지노 게임사 그리드 (2026-06-09) ======
          디자인설정 '레이아웃 > 배치 선택 > 게임사 표시 방식'(design_tokens.layout.provider_grid_mode)으로
          '나열(list, 기본)' / '탭 구분(tabs)' 를 선택한다. 미설정/미인식 값은 list 폴백(현재 화면 무손상).

          [공통] 슬롯=게임목록 팝업(handleSlotProviderClick 전달), 카지노=로비 직진입(HomeCasinoProviderGrid 내장)으로
                 클릭 경로를 핸들러 단에서 분리한다(나열·탭 동일). 운영사 게임종류 토글(isGameTypeEnabled)·블록 표시/숨김 모두 존중.

          [나열 모드] 아래 두 <section>(black-slots / black-casino) 그대로 — 블록 순서·폭·hide-block-* 컨트롤이 함께 적용된다.
          [탭 모드]   단일 래퍼(black-providers-tabs) 1개. 탭 버튼은 slotTabAvailable/casinoTabAvailable 로 게이팅하여
                      게임종류 OFF·블록 숨김 시 해당 탭이 사라진다(나열 모드와 동작 일치). 둘 다 불가면 래퍼 자체를 미렌더. */}
      {providerMode === 'list' ? (
        <>
          {isGameTypeEnabled('slot') && (
            <section className="providers" data-block="black-slots">
              <div className="container">
                <div className="sec-head">
                  <div className="tt"><h2 className="heading-2"><span>슬롯</span></h2></div>
                  <div className="ptabs"><Link to="/slot" className="btn-secondary act">더보기 &rsaquo;</Link></div>
                </div>
                <HomeProviderGrid
                  providers={slotProviders}
                  type="slot"
                  onProviderClick={handleSlotProviderClick}
                  vendorNames={vendorNames}
                />
              </div>
            </section>
          )}
          {isGameTypeEnabled('casino') && (
            <section className="providers" data-block="black-casino">
              <div className="container">
                <div className="sec-head">
                  <div className="tt"><h2 className="heading-2"><span>카지노</span></h2></div>
                  <div className="ptabs"><Link to="/casino" className="btn-secondary act">더보기 &rsaquo;</Link></div>
                </div>
                <HomeCasinoProviderGrid
                  providers={casinoProviders}
                  vendorNames={vendorNames}
                />
              </div>
            </section>
          )}
        </>
      ) : (
        /* 탭 모드 — 가용 탭이 하나라도 있을 때만 래퍼 렌더(둘 다 불가면 나열 모드의 게이팅과 동일하게 미표시) */
        (slotTabAvailable || casinoTabAvailable) && (
          <section className="providers" data-block="black-providers-tabs">
            <div className="container">
              <div className="sec-head">
                {/* [2026-09-30] 제목·설명 = 관리자 '홈 문구 > 게임사'(탭 모드 머리). 설명이 비면 줄 없음 */}
                <div className="tt">
                  <h2 className="heading-2"><span>{homeCopy.title('providers', '게임사')}</span></h2>
                  {homeCopy.desc('providers') && <p className="sub">{homeCopy.desc('providers')}</p>}
                </div>
                <div className="ptabs" role="tablist">
                  {slotTabAvailable && (
                    <button
                      type="button"
                      role="tab"
                      aria-selected={effectiveTab === 'slot'}
                      className={`ptab btn-secondary ${effectiveTab === 'slot' ? 'on' : ''}`}
                      onClick={() => setActiveTab('slot')}
                    >
                      슬롯 <span className="cnt">{slotProviders.length}</span>
                    </button>
                  )}
                  {casinoTabAvailable && (
                    <button
                      type="button"
                      role="tab"
                      aria-selected={effectiveTab === 'casino'}
                      className={`ptab btn-secondary ${effectiveTab === 'casino' ? 'on' : ''}`}
                      onClick={() => setActiveTab('casino')}
                    >
                      카지노 <span className="cnt">{casinoProviders.length}</span>
                    </button>
                  )}
                </div>
              </div>
              {/* effectiveTab 으로 가용성을 렌더 시점에 즉시 반영(전환 직후 1프레임 빈 그리드 방지).
                  슬롯=게임목록 팝업(onProviderClick 전달), 카지노=로비 직진입(HomeCasinoProviderGrid) 분리는 나열 모드와 동일 prop 규칙으로 유지. */}
              {effectiveTab === 'slot' && (
                <HomeProviderGrid
                  providers={slotProviders}
                  type="slot"
                  onProviderClick={handleSlotProviderClick}
                  vendorNames={vendorNames}
                />
              )}
              {effectiveTab === 'casino' && (
                <HomeCasinoProviderGrid
                  providers={casinoProviders}
                  vendorNames={vendorNames}
                />
              )}
            </div>
          </section>
        )
      )}

      {/* ====== 5. 신규게임·추천게임 (2026-07-21) ======
          데이터는 이미 로드 중이던 newGames/recommendedGames 상태(loadGameData)를 소비 — 추가 API 호출 없음.
          .lm-home 직계 자식이라 블록 표시/숨김(hide-block-*)·순서(--block-order-*)·폭(--block-w-*) 컨트롤이
          다른 섹션과 동일 규격으로 적용된다(관리자 디자인설정의 "신규게임"/"추천게임" 항목과 1:1).
          목록이 비면 섹션 자체를 미렌더(빈 껍데기 방지 — 마스터 스위치 게이트로 목록이 빌 수 있음). */}
      {/* [2026-09-30] 제목·설명 = 관리자 '홈 문구 > 신규게임 / 추천게임' */}
      {newGames.length > 0 && (
        <FeaturedArc games={newGames} title={homeCopy.title('new_games', '신규게임')} desc={homeCopy.desc('new_games')} decorBubble={decor.bubble} onCardClick={onGameSlideClick} />
      )}
      {recommendedGames.length > 0 && (
        <RecoFlow games={recommendedGames} title={homeCopy.title('recommended', '추천게임')} desc={homeCopy.desc('recommended')} decorBubble={decor.bubble} onCardClick={onGameSlideClick} />
      )}

      {/* ====== 6. 바로가기 (QUICK LINKS) ====== */}
      {/* [2026-06-08] 빌더 슬롯 — 바로가기 섹션 위 */}
      <WidgetSlot slotKey="home-before-quicklinks" />
      {/* [2026-09-28] 노출할 칸이 하나도 없으면(관리자 '바로가기' 노출을 모두 끔) 제목만 남은 빈 구역을 그리지 않는다.
          WHY: 루미나는 코드 기본 이름("블랙 텔레그램" 등)을 감추려고 네 칸을 모두 끈 상태로 운영될 수 있다 — 그때 "바로가기" 제목만 덩그러니 남았다. */}
      {effectiveQuickLinks.some((l) => l.enabled) && (
      <section className="quick" data-block="black-quicklinks">
        <div className="container">
          <div className="sec-head">
            {/* [2026-09-30] 제목·설명 = 관리자 '홈 문구 > 바로가기' */}
            <div className="tt">
              <h2 className="heading-2"><span>{homeCopy.title('quicklinks', '바로가기')}</span></h2>
              {homeCopy.desc('quicklinks') && <p className="sub">{homeCopy.desc('quicklinks')}</p>}
            </div>
            <div className="row">
              {/* [퀵링크 설정] enabled=false 칸은 숨김. URL 설정 칸(텔레그램·평생도메인)은 클릭 시
                  안내 모달(주소 표시 + 확인=바로가기)을 띄운다. URL 미설정 칸은 기존 무동작 유지. */}
              {effectiveQuickLinks.filter((l) => l.enabled).map((link) => {
                /* 아이콘 토큰이 설정돼 있으면 업로드 이미지, 없으면 기본 아이콘(인라인 SVG) 폴백 */
                const iconUrl = getIconUrl(link.iconKey);
                const handleClick = link.url
                  ? (e) => {
                      e.preventDefault();
                      openModal(link.url, { type: 'confirm', onConfirm: () => window.open(link.url, '_blank', 'noopener,noreferrer') });
                    }
                  : undefined;
                return (
                  <a href={link.url || link.href} className="btn-secondary ql" key={link.iconKey} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
                    {iconUrl ? (
                      <img src={iconUrl} alt="" className="ql-ic" loading="lazy" onError={() => setFailedIconKeys((p) => ({ ...p, [link.iconKey]: true }))} />
                    ) : (
                      <span className="ql-ic">{QUICK_LINK_ICONS[link.iconKey]}</span>
                    )}
                    <span>{link.label}</span>
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      )}

      {/* ====== 7. 스포츠 경기 카드 ====== */}
      {/* [운영사 게임종류 토글] 스포츠 미운영이면 SPORTS 섹션(제목·더보기·경기카드 슬라이더) 전체 비노출.
         enabledGameTypes가 null(비로그인/로딩전)이면 true → 기존과 동일하게 노출(no-op). */}
      {/* [2026-06-08] 빌더 슬롯 — 스포츠 섹션 위 (조건부 렌더 밖에 배치) */}
      <WidgetSlot slotKey="home-before-sports" />
      {/* [2026-09-28] 경기 자료가 없으면 구역을 그리지 않는다(이벤트 구역의 2026-05-03 규칙과 같음).
          WHY: 자료가 없을 때 회색 "경기 준비중 / TBD vs TBD" 빈 카드 5장을 깔았는데(블랙 승계), 스포츠 자료가 들어오지 않는
               운영사(tosino)에서는 늘 빈 카드만 보여 화면이 고장 난 것처럼 보였다. 자료가 도착하면(캐시 포함) 그때 나타난다. */}
      {isGameTypeEnabled('sports') && sportsMatches.length > 0 && (
      <section className="sports" data-block="black-sports">
        <div className="container">
          <div className="sec-head">
            {/* [2026-09-30] 제목·설명 = 관리자 '홈 문구 > 스포츠' */}
            <div className="tt">
              <h2 className="heading-2"><span>{homeCopy.title('sports', '스포츠')}</span></h2>
              {homeCopy.desc('sports') && <p className="sub">{homeCopy.desc('sports')}</p>}
            </div>
            <div className="ptabs">
              <button type="button" className="hs-nav" onClick={() => scrollContainer(sportsScrollRef, -1)} aria-label="Scroll left"><ChevronLeft /></button>
              <button type="button" className="hs-nav" onClick={() => scrollContainer(sportsScrollRef, 1)} aria-label="Scroll right"><ChevronRight /></button>
              <Link to="/sports" className="btn-secondary act">더보기 &rsaquo;</Link>
            </div>
          </div>
          <div className="hs-track" ref={sportsScrollRef}>
            {/* 구역은 경기 자료가 있을 때만 그려지므로(위 조건) 빈 카드 분기는 두지 않는다 */}
            {sportsMatches.map((match, i) => {
                // homeTeam/awayTeam은 {name, id} 객체이므로 .name으로 문자열 추출
                const home = match.homeTeam?.name || match.fixture_home_team || match.home || 'Home';
                const away = match.awayTeam?.name || match.fixture_away_team || match.away || 'Away';
                const league = match.leagueName || match.league?.name || match.league_name || '';
                const startTime = match.startTime || match.fixture_start_time || match.start_time || '';
                const sportType = match.sportType || match.sport_type || '';
                // 배당 추출: 백엔드(user-api sports.js adaptFixtureTable + buildMainMarket)는
                // match.markets[0].outcomes 배열로 배당을 반환하며 outcome.name은
                // getOutcomeName()을 거쳐 '승'/'무'/'패' 한글 라벨로 내려옴.
                // isMain 마켓 우선, 없으면 markets[0]에서 각 outcome을 조회.
                const mainMarket = match.markets?.find(m => m.isMain) || match.markets?.[0];
                const outcomes = mainMarket?.outcomes || [];
                const homeOdds = outcomes.find(o => o.name === '승')?.odds ?? '-';
                const drawOdds = outcomes.find(o => o.name === '무')?.odds ?? '-';
                const awayOdds = outcomes.find(o => o.name === '패')?.odds ?? '-';
                const country = match.league?.country || match.leagueCountry || '';
                const flagUrl = getCountryFlagUrl(country);
                // 팀/리그 로고 — SportsMatchList.jsx와 동일한 user-api 프록시 경로 재사용
                const leagueId = match.league?.leagueId || match.league?.id;
                const homeTeamId = match.homeTeam?.id;
                const awayTeamId = match.awayTeam?.id;
                const leagueLogoUrl = (leagueId && Number(leagueId) > 0)
                  ? `/api/sports/logos/league/${sportType || 'soccer'}/${leagueId}` : null;
                const homeLogoUrl = (homeTeamId && Number(homeTeamId) > 0)
                  ? `/api/sports/logos/team/${sportType || 'soccer'}/${homeTeamId}` : null;
                const awayLogoUrl = (awayTeamId && Number(awayTeamId) > 0)
                  ? `/api/sports/logos/team/${sportType || 'soccer'}/${awayTeamId}` : null;
                /* [2026-05-03] 비로그인 사용자가 카드를 클릭하면 /sports 진입(베팅 페이지)
                   대신 /login 으로 보낸다. /sports 페이지는 베팅이 본 기능이라 로그인이
                   전제이며, 비로그인 진입 시 빈 화면·오류로 흐를 수 있어 명시적 가드. */
                const go = () => navigate(user ? '/sports' : '/login');

                return (
                  <div
                    className="hs-card"
                    key={match.id || i}
                    role="button"
                    tabIndex={0}
                    onClick={go}
                    onKeyDown={onEnterOrSpace(go)}
                  >
                    <div className="lg">
                      <span className="hs-ic">{getSportIconNode(sportType)}</span>
                      {leagueLogoUrl && (
                        <img
                          src={leagueLogoUrl}
                          alt=""
                          className="hs-llogo"
                          loading="lazy"
                          onError={(e) => { e.currentTarget.style.display = 'none'; }}
                        />
                      )}
                      <span className="hs-league">{league}</span>
                      {flagUrl && (
                        <img
                          src={flagUrl}
                          alt=""
                          className="hs-flag"
                          loading="lazy"
                        />
                      )}
                      <span className="hs-date">{formatMatchDate(startTime)}</span>
                    </div>
                    <div className="tm">
                      <span className="team">
                        {homeLogoUrl && (
                          <img
                            src={homeLogoUrl}
                            alt=""
                            className="hs-tlogo"
                            loading="lazy"
                            onError={(e) => { e.currentTarget.style.display = 'none'; }}
                          />
                        )}
                        <span className="hs-team">{home}</span>
                      </span>
                      <span className="vs" aria-label="versus">VS</span>
                      <span className="team away">
                        <span className="hs-team">{away}</span>
                        {awayLogoUrl && (
                          <img
                            src={awayLogoUrl}
                            alt=""
                            className="hs-tlogo"
                            loading="lazy"
                            onError={(e) => { e.currentTarget.style.display = 'none'; }}
                          />
                        )}
                      </span>
                    </div>
                    <div className="odds">
                      <span>승<b>{homeOdds}</b></span>
                      <span>무<b>{drawOdds}</b></span>
                      <span>패<b>{awayOdds}</b></span>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>
      )}

      {/* ====== 8. 이벤트 ====== */
      /* [2026-05-03] 메인고정 이벤트가 0건이면 섹션 전체 비노출.
         과거 placeholder("이벤트 준비중" 5장) 는 등록 데이터가 없는데도 가짜 카드를
         깔아 사용자에게 흉물스럽게 노출되는 문제가 있어 제거한다. eventLoading 동안은
         pinnedEvents.length === 0 이므로 자연스럽게 비노출 → 데이터 도착 시 노출.
         로딩 분기 또한 빈 자리만 보여 무용하므로 함께 제거하여 렌더 단순화.
         더보기 링크는 데이터가 있을 때만 의미가 있으므로 섹션 안에 유지(섹션과 동반 노출). */}
      {/* [2026-06-08] 빌더 슬롯 — 이벤트 섹션 위 (조건부 렌더 밖에 배치) */}
      <WidgetSlot slotKey="home-before-events" />
      {pinnedEvents.length > 0 && (
        <section className="events" data-block="black-events">
          <div className="container">
            <div className="sec-head">
              {/* [2026-09-30] 제목·설명 = 관리자 '홈 문구 > 이벤트' */}
              <div className="tt">
                <h2 className="heading-2"><span>{homeCopy.title('events', '이벤트')}</span></h2>
                {homeCopy.desc('events') && <p className="sub">{homeCopy.desc('events')}</p>}
              </div>
              <div className="ptabs">
                <button type="button" className="hs-nav" onClick={() => scrollContainer(eventsScrollRef, -1)} aria-label="Scroll left"><ChevronLeft /></button>
                <button type="button" className="hs-nav" onClick={() => scrollContainer(eventsScrollRef, 1)} aria-label="Scroll right"><ChevronRight /></button>
                {/* [2026-09-30] 이벤트 구역의 더보기 = 이벤트 탭 — 탭 없이 가면 공지사항 탭(기본값)이 열렸다(실측). 상단 메뉴 "이벤트"와 같은 주소 */}
                <Link to="/mypage/event?tab=event" className="btn-secondary act">더보기 &rsaquo;</Link>
              </div>
            </div>
            <div className="ev-track" ref={eventsScrollRef}>
              {pinnedEvents.map((event) => (
                <Link
                  to={`/mypage/event?tab=event&id=${event.id}`}
                  className="ev"
                  key={event.id}
                >
                  <img
                    className="ev-bg"
                    src={event.bannerImage || '/img/events/main-event-banner.jpg'}
                    alt={event.title}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.style.background =
                        'linear-gradient(135deg, #00003A 0%, #00011A 100%)';
                    }}
                  />
                  <div className="ev-sh"></div>
                  {EVENT_STATUS_LABEL[event.status] && <span className="tag">{EVENT_STATUS_LABEL[event.status]}</span>}
                  <h3 className="heading-3">{event.title}</h3>
                  <p>{event.startDate} ~ {event.endDate}</p>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ====== 9. CTA "지금 시작하기" — 비로그인에게만(회원가입 유도) ====== */}
      {!user && (
        <section className="cta">
          <div className="container">
            {/* [2026-09-30] 링 장식(참고 사이트 아래쪽 긴 글 구간의 두 번째 링 한 쌍 자리) */}
            <DecorRings ring1={decor.ring1} ring2={decor.ring2} />
            {/* [2026-09-30] 제목·안내 문장·버튼 글자 = 관리자 '홈 문구 > 지금 시작하기'(비었을 때 규칙은 위 ctaLine1 계산부) */}
            <h2 className="heading-1">{ctaLine1}{ctaLine2 && <span className="line-2">{ctaLine2}</span>}</h2>
            {ctaDesc && <p>{ctaDesc}</p>}
            <Link to="/register" className="btn-primary">{ctaButtonLabel} <span className="ic"><ArrowIcon /></span></Link>
          </div>
        </section>
      )}

      {/* ══════════════ POPUPS ══════════════ */}

      {/* Provider game list popup — 시안 게임 리스트 팝업(.gl-overlay/.gl-popup): 게임사 캐릭터·이름·게임 수·검색·그리드·닫기, 배경 클릭/ESC 닫힘, 본문 스크롤 잠금
          [2026-10-31] 페이지 맨 바깥(body)에 그린다 — 본문(main)의 겹침 층 1 안에서는 상단 메뉴(60) 밑에 깔려 데스크톱에서 창 윗줄
          (게임사 이름·창 안 "게임 검색..."·닫기)이 가려졌다(2026-10-31 ur3 실측). 이 창의 꾸밈은 전부 화면 이름에 묶이지 않은 공통 규칙이다. */}
      {showProviderPopup && selectedProvider && createPortal(
        <div className="gl-overlay" onClick={closeProviderPopup}>
          <div className="gl-popup" role="dialog" aria-modal="true" aria-labelledby="glTitle" onClick={(e) => e.stopPropagation()}>
            <div className="gl-head">
              <img
                className="gl-chr"
                src={resolveApiImageUrl(selectedProvider.character_hidden !== true && selectedProvider.character_url ? selectedProvider.character_url : selectedProvider.logo_url)}
                alt={selectedProvider.provider || selectedProvider.provider_name}
                onError={(e) => {
                  if (!e.target.dataset.errorHandled) {
                    e.target.dataset.errorHandled = 'true';
                    if (!e.target.src.includes('default-logo.svg')) {
                      e.target.src = '/img/default-logo.svg';
                    } else {
                      e.target.style.display = 'none';
                    }
                  }
                }}
              />
              <div className="gl-tt">
                <h3 id="glTitle">{selectedProvider.provider || selectedProvider.provider_name}</h3>
                <span className="tag">{gameListLoading ? '불러오는 중' : `${providerGames.length} 게임`}</span>
              </div>
              <label className="gl-search">
                <SearchIcon />
                <input
                  type="text"
                  placeholder="게임 검색..."
                  value={searchKeyword}
                  onChange={handleGameSearch}
                  disabled={gameListLoading}
                  className="popup-search-input"
                />
              </label>
              <button type="button" className="gl-close" onClick={closeProviderPopup} aria-label="닫기"><CloseIcon /></button>
            </div>
            <div className="gl-grid">
              <GameListStatus className="gl-empty" loading={gameListLoading} error={gameListError} onRetry={() => handleSlotProviderClick(selectedProvider)} />
              {filteredGames.map((game) => (
                <div
                  key={game.id}
                  className={`gl-item ${isMobileIOS ? 'mobile-ios' : ''}`}
                  role="button"
                  tabIndex={0}
                  onClick={() => handleGameClick(game)}
                  onKeyDown={onEnterOrSpace(() => handleGameClick(game))}
                  style={{
                    '--random-gradient': getCustomGradient(game.id, {
                      opacity: 0.9,
                      startPosition: 62,
                      endPosition: 95,
                      direction: 'to bottom',
                    }),
                  }}
                >
                  <div className="gl-thumb">
                    {/* 이미지 없는 게임 자리표시(.ph, 이니셜) — 썸네일이 실패하면 그림을 숨겨 자리표시가 드러난다 */}
                    <span className="ph" aria-hidden="true">{String(gameDisplayName(game) || '').charAt(0)}</span>
                    <img
                      src={resolveApiImageUrl(game.thumbnail_url || game.image_url)}
                      alt={game.game_name_ko || game.game_name}
                      className="game-thumbnail"
                      loading="lazy"
                      onError={(e) => {
                        if (!e.target.dataset.errorHandled) {
                          e.target.dataset.errorHandled = 'true';
                          e.target.style.display = 'none';
                        }
                      }}
                    />
                  </div>
                  <div className="gl-name">{game.game_name_ko || game.game_name}</div>
                </div>
              ))}
              {!gameListLoading && !gameListError && filteredGames.length === 0 && <div className="gl-empty">검색 결과가 없습니다</div>}
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* Game launch popup */}
      {showGamePopup && (
        <GamePopup
          game={selectedGame}
          gameUrl={gameUrl}
          onClose={() => {
            setShowGamePopup(false);
            setGameUrl('');
            setSelectedGame(null);
            setCustomTitle(null);
            // [2026-08-21] 회원이 덧창을 직접 닫았다 → 확정 종료.
            gamesService.endGame(true).catch((err) => {
              console.error('게임 종료 처리 실패:', err);
            });
          }}
          loading={gameLoading}
          customTitle={customTitle}
        />
      )}

      {/* WHY: 실패 사유 안내용 공용 모달 — createPortal(body)라 레이아웃·스크롤 무영향.
          id는 상단바(TopNavBar)의 'alertModal'과 충돌 방지를 위해 페이지 고유값 사용(스타일은 class 기반이라 영향 없음). */}
      <Modal id="homeAlertModal" isOpen={isAlertOpen} onClose={closeAlert} text={alertConfig.text} type={alertConfig.type} onConfirm={alertConfig.onConfirm} />
    </div>
  );
};

export default HomePage;
